"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const TypographyStyles = (0, _styles.makeStyles)({
  root: {
    fontFamily: 'Proxima, Roboto, Arial, sans-serif',
    letterSpacing: 0,
    whiteSpace: 'normal',
    '&.headerTypography': {
      [_theme.default.breakpoints.up('mobile')]: {
        fontSize: _theme.default.typography.pxToRem(14),
        lineHeight: _theme.default.typography.pxToRem(17)
      },
      [_theme.default.breakpoints.up('desktop')]: {
        fontSize: _theme.default.typography.pxToRem(16),
        lineHeight: _theme.default.typography.pxToRem(19.5)
      }
    }
  }
});
var _default = exports.default = TypographyStyles;